import { styled } from '@mui/material';

import { shouldForwardProps } from '../../../utils/mui-styled.utils';

export const StyledCarouselRenderedRoot = styled('div', {
	shouldForwardProp: shouldForwardProps(['extraPadding']),
})<{ extraPadding?: boolean }>(
	({
		theme: {
			palette: { sizes },
		},
		extraPadding,
	}) => ({
		marginTop: 5,
		...(extraPadding && {
			paddingBottom: sizes.size_2,
		}),
	}),
);

export const StyledCarouselRenderedLocationRoot = styled('div')(
	({
		theme: {
			palette: { sizes },
		},
	}) => ({
		padding: `0 ${sizes.size_1}%`,
	}),
);

export const StackedButtonsContainer = styled('div')({
	paddingLeft: 0,
	paddingRight: 0,
	'& > div': {
		userSelect: 'text',
		width: '100%',
	},
});
